module.exports = __webpack_public_path__ + "static/media/GenJyuuGothic-Heavy.f7f9dd84.ttf";